import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import { useNavigate, useParams } from "react-router-dom";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";

export const CoachAdminLoadvelocityTestResult = () => {
  const { staff } = useStaffAuthContext();
  const { coach_id } = useParams();

  const [testResults, setTestResults] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTestResults = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL.GET_COACH_LOADVELOCITY_ADMIN_TEST_RESULT}${coach_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched test results:', data);  // Debugging: Check what data is returned

        if (response.ok && data.success) {
          setTestResults(data.data);  // Make sure you're accessing data.data
        } else {
          setError(data.error || "No valid data found");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTestResults();
  }, [coach_id, staff.token]);

  const renderTable = (title, data) => {
    if (!data || Object.keys(data).length === 0) {
      return <p className="text-red-500">No data available or invalid format.</p>;
    }

    return (
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-4">{title}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto bg-white border border-gray-200 rounded-lg shadow-md">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-3 px-6 text-left">Parameters</th>
                <th className="py-3 px-6 text-left">Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(data).map(([key, value]) => (
                <tr key={key} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-6">{key.replace(/([A-Z])/g, " $1").toUpperCase()}</td>
                  <td className="py-3 px-6">
                    {typeof value === 'object' && value !== null ? JSON.stringify(value) : value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="flex h-screen">
      <StaffSideMenu />
      <div className="flex-1 p-6 bg-gray-100 pt-16">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-semibold">Coach Test Results</h1>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Go Back
          </button>
        </div>

        {loading ? (
          <p className="text-center text-gray-500">Loading test results...</p>
        ) : error ? (
          <p className="text-center text-red-500">{error}</p>
        ) : (
          testResults && Object.keys(testResults).length > 0 ? (
            renderTable("Runrocket Test Results", testResults)
          ) : (
            <p className="text-center text-red-500">No test results available</p>
          )
        )}
      </div>
    </div>
  );
};
